const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em"
         height="1em"
         fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2ZM7.71429 6C7.71429 4.73763 8.73763 3.71429 10 3.71429C11.2624 3.71429 12.2857 4.73763 12.2857 6C12.2857 7.26237 11.2624 8.28571 10 8.28571C8.73763 8.28571 7.71429 7.26237 7.71429 6Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            d="M16.3025 14.7646C15.0309 12.4411 12.6184 11 10 11C7.38165 11 4.96909 12.4411 3.6975 14.7646L3.19566 15.6816C2.62642 16.7217 3.36734 18 4.5395 18H15.4605C16.6326 18 17.3736 16.7217 16.8043 15.6816L16.3025 14.7646ZM5.20446 15.6144C6.172 13.8464 8.00771 12.75 10 12.75C11.9923 12.75 13.828 13.8464 14.7955 15.6144L15.1434 16.25H4.85665L5.20446 15.6144Z"
            fill="currentColor"
        />
    </svg>
);

export default UserIcon;
